import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable } from "rxjs";

/**
 * T -> Response
 * K -> Request
 */
export abstract class AbstractDatasource<T, K> implements DataSource<T> {

    private _resultsSubject = new BehaviorSubject<T[]>([]);
    private _currentPage: T[] = [];
    private _loadingSubject = new BehaviorSubject<boolean>(false);
    private _length = 0;
    private _refreshPaginator = new BehaviorSubject<boolean>(false);

    get resultSubject(): BehaviorSubject<T[]> {
        return this._resultsSubject;
    }

    get loadingSubject(): BehaviorSubject<boolean> {
        return this._loadingSubject;
    }

    get refreshPaginatorSubject(): BehaviorSubject<boolean> {
        return this._refreshPaginator;
    }

    get loading$(): Observable<boolean> {
        return this._loadingSubject.asObservable();
    }

    get refreshPaginator$(): Observable<boolean> {
        return this._refreshPaginator.asObservable();
    }

    get length(): number {
        return this._length;
    }

    set length(val: number) {
        this._length = val;
    }

    get currentPage(): T[] {
        return this._currentPage;
    }

    set currentPage(val: T[]) {
        this._currentPage = val;
    }

    /**
       * Called once at table bootstrap time. 
       * The values of that observable contain the data that the Data Table needs to display.
       * @param collectionViewer 
       * @returns 
       */
    connect(collectionViewer: CollectionViewer): Observable<T[]> {
        return this._resultsSubject.asObservable();
    }

    /**
     * Called once by the data table at component destruction time to avoid memory leaks.
     * @param collectionViewer 
     */
    abstract disconnect(collectionViewer: CollectionViewer);

    abstract search(searchObj: K);

}